import { TICKER_FILTER } from "../../../types";

export const isTickerFilter = (tickerFilter: string | undefined): boolean => {
	if (!tickerFilter) return false;

	return Object.values(TICKER_FILTER).includes(tickerFilter as TICKER_FILTER);
};
